/**
 * Medallia docs: https://docs.medallia.com/en/medallia-digital/medallia-digital-web/architecture/single-page-architecture-spa-compatibility-guidelines
 */
export function updatePageView() {
  if (
    typeof window !== 'undefined' &&
    window.KAMPYLE_ONSITE_SDK &&
    typeof window.KAMPYLE_ONSITE_SDK.updatePageView === 'function'
  ) {
    window.KAMPYLE_ONSITE_SDK.updatePageView();
  }
}
